import type { ComponentType } from 'react';

import type { GenericPostDetailProps } from '@/features/posts/components/detail/GenericPostDetailView';

export const MEINE_REGION_FEED_ROUTE = 'feed';

export enum RegionTab {
  MINISTRIES = 'ministries',
  REGIONAL_RADIO = 'regionalRadio',
  EMERGENCY = 'emergency',
  EVENTS = 'events'
}

export enum EmergencyOrg {
  POLICE = 'polizei',
  FIRE_BRIGADE = 'feuerwehr',
  RED_CROSS = 'rotkreuz',
  WATER_RESCUE = 'wasserwacht'
}

export type SvgIconProps = {
  fill?: string;
  width?: number;
  height?: number;
};

export type RegionPageTab = {
  key: RegionTab;
  label: string;
  icon: ComponentType<SvgIconProps>;
  dot?: boolean;
};

export type RegionFeedPost = {
  post: GenericPostDetailProps;
  tab: RegionTab;
  emergencyOrg?: EmergencyOrg;
  distanceKm?: number;
};

export type RegionFilterChange = { tab: RegionTab.EVENTS; radiusKm: number };
